import { render, staticRenderFns } from "./printingPreviewMaterial.vue?vue&type=template&id=6ddc5e8e&scoped=true&"
import script from "./printingPreviewMaterial.vue?vue&type=script&lang=js&"
export * from "./printingPreviewMaterial.vue?vue&type=script&lang=js&"
import style0 from "./printingPreviewMaterial.vue?vue&type=style&index=0&id=6ddc5e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddc5e8e",
  null
  
)

export default component.exports